export default __webpack_public_path__ + "d14484b.png";